import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-cambia-stato',
  templateUrl: './cambia-stato.component.html',
  styleUrls: ['./cambia-stato.component.css']
})
export class CambiaStatoComponent implements OnInit {
	@Input() data: any = null;
	@Input() writePermission: boolean = false;
	@Output() innerEvents = new EventEmitter();

	uid: any = 0;
	activeFlowSync: Subscription;
	flowContent: any = {
		stateSettings : {},
		customStates : [],
		defaultStates : [],
		workflow : {
			states : [],
			connections : {}
		}
	};
	nextStateSelected = "all";

	constructor(private dataService: DataService) {}

	ngOnInit() {
		this.activeFlowSync = this.dataService.activeFlow$.subscribe(
			activeFlow => {
				if (activeFlow) {
					this.flowContent = activeFlow.contenuto;
				}
			});
	}

	ngOnChanges(changes: any){
		if (changes.data) {
			if(changes.data.currentValue.uid && this.data.uid > 0){
				this.uid = this.data.uid;
			}
		}
	}

	reset(){
		this.nextStateSelected = "all";
	}

	hide(){
		let event: any = {
			hide: true
		}
		this.reset();
		this.innerEvents.emit(event);
	}

	cambiaStato(){
		let event: any = {
			hide: true,
			cambiaStato: true,
			uid: this.uid,
			id_stato: this.nextStateSelected
		}
		this.reset();
		this.innerEvents.emit(event);
	}

	ngOnDestroy() {
		this.activeFlowSync.unsubscribe();
	}
}
